<template>
  <div>
    <VForm
      :name="name"
      :fields="formData"
      :initialValues="initialValues"
      @change="onChangeInputSave"
      @blur="onBlurInputSave"
    ></VForm>
    <div v-show="!_getUrlFiledValue" class="separator">Or</div>
    <VUploaderDropZone
      v-show="!_getUrlFiledValue"
      :fileTypes="fileTypes"
      @upload-start="$emit('upload-start')"
      @upload-finish="(file, file_type) => onFileUploadFinish(file, file_type)"
    ></VUploaderDropZone>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VForm from "@/components/VForm";
import withFormUtils from "@/mixins/withFormUtils";
import { required, url } from "@/utils/validations";
import VUploaderDropZone from "@/components/VUploaderDropZone";

export default Vue.component("LettersUploaderUrl", {
  props: {
    template: VueTypes.object,
    fileTypes: VueTypes.string
  },

  components: {
    VForm,
    VUploaderDropZone
  },

  mixins: [withFormUtils],

  data() {
    return {
      name: "lettersBuilder",
      timerUrlSave: 0,
      formData: [
        {
          name: "file_url",
          elementType: "text",
          label: "PDF URL",
          placeholder: "Paste URL",
          required: true,
          validate: [required, url]
        }
      ]
    };
  },

  computed: {
    initialValues() {
      return { file_url: this.template.file_url };
    },

    _getUrlFiledValue() {
      return this.getValue("file_url");
    },

    shouldPdfUrlUpdate() {
      this.validateForm();
      return this.isValid && this._getUrlFiledValue !== this.template.file_url;
    }
  },

  methods: {
    onChangeInputSave(command) {
      clearTimeout(this.timerUrlSave);
      if (command !== "stop" && this.shouldPdfUrlUpdate) {
        this.timerUrlSave = setTimeout(() => this.$emit("savePdfUrl"), 3000);
      }
    },

    onBlurInputSave() {
      /*reset to previous value if blur after string deleted*/
      // if (this.template.file_url && !this._getUrlFiledValue) {
      //   this.updateValue({
      //     formName: this.name,
      //     fieldName: "file_url",
      //     value: this.template.file_url
      //   });
      // }

      if (this.shouldPdfUrlUpdate) {
        this.onChangeInputSave("stop");
        this.$emit("savePdfUrl");
      }
    },

    onFileUploadFinish(file, file_type) {
      this.updateValue({
        formName: this.name,
        fieldName: "file_url",
        value: `https://f001.backblazeb2.com/b2api/v2/b2_download_file_by_id?fileId=${file}`
      });
      this.$emit("upload-finish", file, file_type);
      this.clearFieldErrors("file_url");
    }
  }
});
</script>

<style lang="scss" scoped>
.separator {
  margin: 20px 0;
  text-align: center;
  font-family: Lato-Bold, Arial, sans-serif;
  color: $secondary-text-color;
}
</style>
